import React, { useState, useRef, useEffect } from "react";
import { getChatService } from "../../services/vod/vod.service";

const ChatComponent = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSend = async () => {
    if (!input.trim() || loading) return;

    const userMessage = { sender: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);
    setInput("");
    setLoading(true);

    try {
      const response = await getChatService(input);
      const botMessage = {
        sender: "bot",
        text: response?.data?.choices[0]?.message?.content || "No response",
      };
      setMessages((prev) => [...prev, botMessage]);
    } catch (error) {
      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: "Error: Unable to get response." },
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="panel panel-default chatbot-panel">
      <div className="panel-heading padding-for-chat-header">
        هوش مصنوعی طلایی شو
      </div>

      <div
        className="panel-body"
        style={{ flex: 1, overflowY: "auto", marginBottom: "10px" }}
      >
        {messages.map((msg, idx) => (
          <div
            key={idx}
            className={`alert ${
              msg.sender === "user"
                ? "alert-primary text-right"
                : "alert-info text-left"
            }`}
            style={{ clear: "both" }}
          >
            {msg.text}
          </div>
        ))}

        {loading && (
          <div
            className="alert alert-info text-right"
            style={{ clear: "both" }}
          >
            <i className="glyphicon glyphicon-refresh glyphicon-spin"></i> ربات
            در حال پاسخ گویی ...
          </div>
        )}

        <div ref={messagesEndRef}></div>
      </div>

      <div className="input-group chat-input-items">
        <input
          type="text"
          className="form-control input-text-chat"
          placeholder="پیام خود را برای ربات هوشمند ارسال کنید ..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
          disabled={loading}
        />
        <span className="input-group-btn">
          <button
            className={`btn btn-primary ${loading ? "disabled" : ""}`}
            onClick={handleSend}
            disabled={loading}
          >
            ارسال
          </button>
        </span>
      </div>
    </div>
  );
};

export default ChatComponent;
